export const state = {
    isShowLoading: true,
    count: 123, 
    pageSize:50,
    isRead:false,
    SystemId:'42a54287-0404-4091-893b-ab6c56b6ff0c',
    // username:'KABI\\CN0086200360',//谢芳    
    // username:'KABI\\CN0863010988',//霍雅卓
    // username:'KABI\\CN0863010943',//涂芳
    // username:'KABI\\CN0086206935',//杨黎黎
    // username:'KABI\\CN0863010334',//徐莉BUEN
    // username:'KABI\\CN0086207404',//王玉华
    // username:'KABI\\CN0863000557',//章剑
    list: [1, 3, 5, 7, 9, 20, 30]
};